import Vue from 'vue'
import Vuex from 'vuex'

// Per guardar estat quan tancam el navegador
//import createPersistedState from "vuex-persistedstate";

import user from './store/modules/user'
import auth from './store/modules/auth'
import comunidades from './store/modules/comunidades'
import documentos from './store/modules/documentos'
import notificaciones from './store/modules/notificaciones'
import propiedades from './store/modules/propiedades'
import extracto from './store/modules/extracto'
import liquidaciones from './store/modules/liquidaciones'
import incidencias from './store/modules/incidencias'
import cuestionarios from './store/modules/cuestionarios'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    auth,
    comunidades,
    propiedades,
    documentos,
    notificaciones,
    extracto,
    liquidaciones,
    incidencias,
    cuestionarios
  },
  //plugins: [createPersistedState()],
  strict: debug,
})